var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H2A2 2 0 00.01 2L0 14a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2h-8z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAxNiI+CiAgICA8cGF0aAogICAgICAgICAgICBkPSJNMTAsNEg0QTIsMiwwLDAsMCwyLjAxLDZMMiwxOGEyLjAwNiwyLjAwNiwwLDAsMCwyLDJIMjBhMi4wMDYsMi4wMDYsMCwwLDAsMi0yVjhhMi4wMDYsMi4wMDYsMCwwLDAtMi0ySDEyWiIKICAgICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTQpIgogICAgLz4KPC9zdmc+";
export { SvgFolderFilled as ReactComponent };